<template>
	<div>
		<div v-if="!step || step === 1" class="u-container">
			<CheckPassword @changeStep="changeStep"></CheckPassword>
		</div>
		<div v-if="step === 2" class="u-container">
			<EditUserForm></EditUserForm>
		</div>
	</div>
</template>

<script>
import CheckPassword from '@/components/CheckPassword';
import EditUserForm from '@/components/EditUserForm';

export default {
	components: {
		CheckPassword,
		EditUserForm,
	},
	data() {
		return {
			step: 1,
		};
	},
	methods: {
		changeStep(step) {
			this.step = step;
		},
	},
};
</script>
